module.exports = __webpack_public_path__ + "12_hair_gold.d8669051.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/12_hair_gold.png
// module id = 1of2
// module chunks = 0